/**
 * Component adapted from SEAC Corporate Website
 * https://github.com/oozou/seac-corporate-website/blob/v1.0.3/packages/web/src/common/components/TagItems.tsx
 */

import cx from 'classnames';
import { FC } from 'react';

export enum ThemeScheme {
  YNU = 'ynu',
  SEAC = 'seac',
}

interface ITagItems {
  isCurrent: boolean;
  onClick: () => void;
  name: string;
  theme: ThemeScheme;
  className?: string;
}

const COLOR_PALETTE = {
  [ThemeScheme.YNU]: {
    current: 'bg-brand-ynu-orange text-white',
    default: 'hover:bg-orange-ynu-200 bg-gray-ynu-100',
  },
  [ThemeScheme.SEAC]: {
    current: 'bg-maroon-200 border text-brand-primary border-brand-primary',
    default:
      'bg-white border border-gray-200 hover:border-brand-primary hover:text-brand-primary',
  },
};

const TagItems: FC<ITagItems> = ({
  isCurrent,
  onClick,
  name,
  theme,
  className,
}) => {
  return (
    <div
      className={cx(
        'shrink-0 cursor-pointer rounded-3xl transition-colors',
        className,
        {
          [`${COLOR_PALETTE[theme].current} font-semibold`]: isCurrent,
          [`${COLOR_PALETTE[theme].default} font-regular text-black`]:
            !isCurrent,
        },
      )}
      onClick={() => onClick()}
    >
      <p className="px-4 py-1.5 text-body">{name}</p>
    </div>
  );
};

export default TagItems;
